import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import "./details.css";
import { StepConnector } from "@material-ui/core";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center"
  },
  active: {
    color: "rgb(52, 107, 235)",
    width: 15,
    height: 22,
    borderRadius: "50%"
  },
  circle: {
    width: 15,
    height: 15,
    borderRadius: "50%",
    backgroundColor: "currentColor"
  },
  completed: {
    color: " rgb(52, 107, 235)",
    zIndex: 1,
    fontSize: 18,
    width: 15,
    height: 15,
    borderRadius: "50%",
    backgroundColor: "currentColor"
  }
});
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    "& $line": {
      backgroundColor: "rgb(52, 107, 235)"
    }
  },
  completed: {
    "& $line": {
      backgroundColor: "rgb(52, 107, 235)"
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1
  }
})(StepConnector);

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active
      })}
    >
      {completed ? (
        <div className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool
};

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

function getSteps() {
  return ["Suspect", "Prospect", "Opportunity"];
}

export default function CustomizedSteppers(props) {
  const classes = useStyles();
  // const [activeStep, setActiveStep] = React.useState(obj[props.Status]);
  const steps = getSteps();
  return (
    <div className={classes.root}>
      <div className="Step">
        <Stepper
          alternativeLabel
          activeStep={
            props.Status === "SUSPECT" ? 0 : props.Status === "PROSPECT" ? 1 : 2
          }
          connector={<ColorlibConnector />}
        >
          {steps.map(label => (
            <Step key={label}>
              <StepLabel
                className={classes.active}
                StepIconComponent={QontoStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div></div>
      </div>
    </div>
  );
}
